import React, { useState } from "react";
import API from "../../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import "../Category/Category.css";

const CategoryAdd = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        language_id: "",
        category: "",
        description: "",
        createdBy: 1,
        updatedBy: 1,
    });

    const [popup, setPopup] = useState({ show: false, type: "", message: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.language_id || !formData.category || !formData.description) {
            setPopup({
                show: true,
                type: "info",
                message: "Please fill all required fields.",
            });
            return;
        }

        setIsSubmitting(true);
        API.post("add_category/add", formData)
            .then((res) => {
                const success = res.data?.success;
                const message = res.data?.message || "Category added successfully!";
                setPopup({
                    show: true,
                    type: success ? "success" : "error",
                    message,
                });

                // if (success) {
                //     setTimeout(() => navigate("/category"), 2000);
                // }
            })
            .catch((err) => {
                console.error("Add Category Error:", err);
                setPopup({
                    show: true,
                    type: "error",
                    message: "Failed to add category. Please try again.",
                });
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <div className="category-container1">
            {/* Header */}
            <div className="category-header1">
                <h2 className="category-title1">Add FAQ Category</h2>
                <div className="header-buttons">
                    <button onClick={handleSubmit} className="btn saves-btn">
                        {isSubmitting ? "Save" : "Save"}
                    </button>
                    <button onClick={() => navigate("/category")} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>

            {/* Form */}
            <div className="category-form-card">
                <form>
                    <div className="cate-form-row">
                        <div className="cate-form-field">
                            <label>Language <span className="required">*</span></label>
                            <select
                                name="language_id"
                                value={formData.language_id}
                                onChange={handleChange}
                            >
                                <option value="">Select Language</option>
                                <option value="1">English</option>
                                <option value="2">Français</option>
                            </select>
                        </div>
                        <div className="cate-form-field">
                            <label>Category Name <span className="required">*</span></label>
                            <input
                                type="text"
                                name="category"
                                placeholder="Enter category name"
                                value={formData.category}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Description below */}
                    <div className="form-group1">
                        <label>Description <span className="required">*</span></label>
                        <textarea
                            name="description"
                            placeholder="Enter description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>
                </form>
            </div>


            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            {/* <button
                                className="btn ok-btn"
                                onClick={() => setPopup({ ...popup, show: false })}
                            >
                                OK
                            </button> */}
                                <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/category");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CategoryAdd;
